import React from "react";
import { View, Text, Button, Platform } from "react-native";
import StyleSheet from "react-native-media-query";
import Color from "../../assets/color/Color";
import { theme } from "../../theme/theme";

const MobileAlertView = (props: any) => {
  // assign props variable ::
  let title = props.title;
  let message = props.message;

  return (
    <View style={styles.container} dataSet={{ media: ids.container }}>
      <Text style={styles.title} dataSet={{ media: ids.title }}>
        {title}
      </Text>
      <Text style={styles.message} dataSet={{ media: ids.message }}>
        {message}
      </Text>
      <View style={styles.bottomView} dataSet={{ media: ids.bottomView }}>
        {Platform.OS !== "android" && (
          <View style={styles.borderView} dataSet={{ media: ids.borderView }} />
        )}
        <Button
          //   style={styles.button}
          //   dataSet={{media: ids.button}}
          title="OK"
          onPress={() => props.closeAlert()}
        />
      </View>
    </View>
  );
};

const { ids, styles } = StyleSheet.create({
  container: {
    backgroundColor: theme.colors.white,
    padding: theme.spacing.reg,
    width: 300,
    borderRadius: theme.radius.sm,
    overflow: "hidden",
  },
  title: {
    textAlign: "center",
    marginTop: theme.margin.sm,
    color: theme.colors.text.primary,
    fontWeight: theme.fontweight.medium as any,
    fontSize: theme.fontsize.mmd,
  },
  message: {
    textAlign: "center",
    marginTop: theme.margin.reg,
    color: theme.colors.text.primary,
    fontWeight: theme.fontweight.xlight as any,
    fontSize: theme.fontsize.reg,
  },
  bottomView: {
    flexDirection: "column",
    justifyContent: "space-evenly",
    marginTop: theme.margin.md,
  },
  borderView: {
    height: 1,
    width: "120%",
    left: -12,
    backgroundColor: "lightgrey",
    marginBottom: theme.margin.xxs,
  },
  button: {
    fontWeight: theme.fontweight.medium as any,
    fontSize: theme.fontsize.xlg,
  },
});

export default MobileAlertView;
